<script lang="ts">
    import src from './svg/arrow_drop_up_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
    export let style: string = '';
</script>

<TemplateIcon {src} {scale} {style} alt="Drop up" on:click />
